<template>
  <div class="dispute-submit-container">
    <el-card class="order-card">
      <div class="page-header">
        <h2>提交争议/复测申请</h2>
        <div class="header-actions">
          <el-button @click="$router.back()">返回</el-button>
        </div>
      </div>
      
      <el-form ref="disputeForm" :model="disputeForm" :rules="rules" label-width="120px" label-position="right">
        <el-divider content-position="left">
          <span class="divider-title">项目信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="项目名称">
              <el-input v-model="orderInfo.projectName" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="订单号">
              <el-input v-model="orderInfo.orderNo" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="客户名称">
              <el-input v-model="orderInfo.customer" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系人">
              <el-input v-model="orderInfo.contact" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">商家信息</span>
        </el-divider>
        
        <el-row :gutter="24">
          <el-col :span="12">
            <el-form-item label="商家名称">
              <el-input v-model="orderInfo.merchant" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="仪器信息">
              <el-input v-model="orderInfo.equipment" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        
        <el-divider content-position="left">
          <span class="divider-title">测试要求附件</span>
        </el-divider>
        
        <div class="file-list-container" v-if="orderFiles.length > 0">
          <el-table
            :data="orderFiles"
            style="width: 100%; margin-bottom: 15px;"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)" 
                  style="margin-left: 10px;">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="no-file">
          <el-empty description="暂无附件"></el-empty>
        </div>
        
        <el-divider content-position="left">
          <span class="divider-title">测试结果附件</span>
        </el-divider>
        
        <div class="file-list-container" v-if="testResultFiles.length > 0">
          <el-table
            :data="testResultFiles"
            style="width: 100%; margin-bottom: 15px;"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="150"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)" 
                  style="margin-left: 10px;">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-else class="no-file">
          <el-empty description="暂无附件"></el-empty>
        </div>
        
        <el-divider content-position="left">
          <span class="divider-title">提出争议/复测申请</span>
        </el-divider>
        
        <el-card class="dispute-form-card">
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item :label="disputeForm.disputeType === 'dispute' ? '提出争议原因' : '申请复测说明'" prop="disputeReason">
                <el-input 
                  type="textarea" 
                  v-model="disputeForm.disputeReason" 
                  :rows="4"
                  :placeholder="disputeForm.disputeType === 'dispute' ? '请详细说明提出争议的原因' : '请详细说明申请复测的原因'">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          
          <el-row :gutter="24">
            <el-col :span="24">
              <el-form-item label="上传附件">
                <el-upload
                  class="upload-demo"
                  action=""
                  :http-request="customUpload"
                  multiple
                  drag
                  :show-file-list="false"
                  :on-preview="handlePreview"
                  :on-remove="handleRemove"
                  :on-error="handleError"
                  :before-upload="beforeUpload">
                  <i class="el-icon-upload"></i>
                  <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  <div class="el-upload__tip" slot="tip">
                    支持上传PDF、Word、Excel或图片格式文件，每个文件不超过10MB。
                    请上传能够证明争议/复测理由的相关文件。
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        
        <div class="uploaded-files" v-if="disputeForm.fileList.length > 0">
          <h3 class="file-list-title">已上传文件</h3>
          <el-table
            :data="disputeForm.fileList"
            style="width: 100%"
            border>
            <el-table-column
              prop="name"
              label="文件名"
              min-width="300">
            </el-table-column>
            <el-table-column
              prop="size"
              label="大小"
              width="150">
              <template slot-scope="scope">
                {{ formatFileSize(scope.row.size) }}
              </template>
            </el-table-column>
            <el-table-column
              label="操作"
              width="180"
              align="center">
              <template slot-scope="scope">
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handlePreview(scope.row)">预览</el-button>
                <el-button 
                  type="text" 
                  size="small" 
                  @click="handleDownload(scope.row)"
                  style="margin-left: 10px;">下载</el-button>
                <el-button 
                  type="text" 
                  size="small"
                  style="color: #F56C6C; margin-left: 10px;"
                  @click="handleRemoveUploaded(scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        
        <el-row :gutter="24" style="margin-top: 30px;">
          <el-col :span="24">
            <div class="form-actions">
              <el-button type="primary" @click="submitForm" :loading="loading">提交申请</el-button>
              <el-button @click="cancel">取消</el-button>
            </div>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import adminApi from '@/api/adminApi'

export default {
  name: 'DisputeSubmit',
  props: {
    role: {
      type: String,
      required: true,
      validator: value => ['admin', 'merchant', 'customer'].includes(value)
    }
  },
  data() {
    return {
      orderId: null,
      orderInfo: {
        projectName: '',
        orderNo: '',
        customer: '',
        contact: '',
        merchant: '',
        equipment: ''
      },
      orderFiles: [], // 测试要求附件
      testResultFiles: [], // 测试结果附件
      disputeForm: {
        disputeType: 'dispute', // dispute: 争议, retest: 复测
        disputeReason: '',
        fileList: []
      },
      rules: {
        disputeReason: [
          { required: true, message: '请输入申请原因', trigger: 'blur' }
        ]
      },
      loading: false,
      uploadHeaders: {
        Authorization: localStorage.getItem('token') || ''
      }
    }
  },
  created() {
    // 从路由参数获取订单ID
    this.orderId = this.$route.params.id
    // 从查询参数获取申请类型
    const disputeType = this.$route.query.type
    if (disputeType && (disputeType === 'dispute' || disputeType === 'retest')) {
      this.disputeForm.disputeType = disputeType
    }
    
    if (this.orderId) {
      this.fetchOrderDetail()
    } else {
      this.$message.error('订单ID不能为空')
      this.$router.push(`/${this.role}/orders/all`)
    }
  },
  methods: {
    // 获取订单详情
    async fetchOrderDetail() {
      this.loading = true
      try {
        // 调用API获取订单详情
        const res = await adminApi.getOrderById(this.orderId)
        if (res) {
          // 映射订单数据到表单
          this.orderInfo = {
            projectName: res.projectName || '',
            orderNo: res.orderSn || '',
            customer: res.customerName || '',
            contact: res.customerPerson || '',
            merchant: res.merchantName || '',
            equipment: res.deviceName || ''
          }
          
          // 处理测试要求附件
          if (res.orderFile && Array.isArray(res.orderFile)) {
            this.orderFiles = res.orderFile.map(file => ({
              name: file.fileName || '未命名文件',
              size: file.fileSize || 0,
              uploadTime: file.uploadTime || new Date(),
              url: file.fileUrl || file.url || '',
              status: 'success'
            }))
          }
          
          // 处理测试结果附件
          if (res.orderResultFile && Array.isArray(res.orderResultFile)) {
            this.testResultFiles = res.orderResultFile.map(file => ({
              name: file.fileName || '未命名文件',
              size: file.fileSize || 0,
              uploadTime: file.uploadTime || new Date(),
              url: file.fileUrl || file.url || '',
              status: 'success'
            }))
          }
        } else {
          this.$message.error('获取订单详情失败')
        }
      } catch (error) {
        console.error('获取订单详情失败:', error)
        this.$message.error('获取订单详情失败: ' + (error.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    // 格式化文件大小
    formatFileSize(size) {
      if (!size) return '0 B'
      const units = ['B', 'KB', 'MB', 'GB']
      let index = 0
      while (size >= 1024 && index < units.length - 1) {
        size /= 1024
        index++
      }
      return `${size.toFixed(2)} ${units[index]}`
    },
    // 预览文件
    handlePreview(file) {
      // 调用统一的预览方法
      adminApi.previewFile(file, this.$message)
        .catch(error => {
          console.error('文件预览失败:', error);
        });
    },
    // 下载文件
    handleDownload(file) {
      // 调用统一的下载方法
      adminApi.downloadFileUnified(file, this.$message)
        .catch(error => {
          console.error('文件下载失败:', error);
        });
    },
    // 删除文件
    handleRemove(file, fileList) {
      this.disputeForm.fileList = fileList
    },
    // 删除已上传文件
    handleRemoveUploaded(index) {
      this.disputeForm.fileList.splice(index, 1)
    },
    // 上传文件错误处理
    handleError(err) {
      console.error('上传文件错误', err)
      this.$message.error('文件上传失败，请重试')
    },
    // 上传前验证
    beforeUpload(file) {
      const isValidType = this.validateFileType(file)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error('只能上传PDF、Word、Excel或图片格式文件')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过10MB')
        return false
      }
      return true
    },
    // 验证文件类型
    validateFileType(file) {
      const validTypes = [
        'application/pdf',
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/vnd.ms-excel',
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        'image/jpeg',
        'image/png',
        'image/gif'
      ]
      return validTypes.includes(file.type)
    },
    // 自定义上传方法
    customUpload({ file }) {
      // 调用上传接口
      adminApi.uploadFile(file, this.orderInfo.customerId, (percent) => {
        console.log(`上传进度: ${parseInt(percent)}%`)
      }).then(res => {
        if (res) {
          const fileData = res
          
          // 确保URL是完整的URL
          let fileUrl = fileData.url || fileData.fileUrl
          if (fileUrl && !fileUrl.startsWith('http') && !fileUrl.startsWith('blob:')) {
            fileUrl = adminApi.ApiUrl + (fileUrl.startsWith('/') ? '' : '/') + fileUrl
          }
          
          // 创建文件对象
          const newFile = {
            name: fileData.fileId,
            size: file.size,
            uploadTime: new Date(),
            url: fileUrl,
            fileId: fileData.fileId || fileData.id,
            path: fileData.path || '',
            status: 'success'
          }
          
          // 将文件添加到上传列表
          this.disputeForm.fileList.push(newFile)
          this.$message.success(`文件 ${file.name} 上传成功`)
        } else {
          this.$message.error(`文件 ${file.name} 上传失败，请重试`)
        }
      }).catch(error => {
        console.error('文件上传失败:', error)
        this.$message.error(`文件 ${file.name} 上传失败: ${error.message || '未知错误'}`)
      })
    },
    // 提交表单
    submitForm() {
      this.$refs.disputeForm.validate(valid => {
        if (valid) {
          this.loading = true
          // 调用API提交数据
          const params = {
            orderSn: this.orderInfo.orderNo,
            disputeType: this.disputeForm.disputeType === 'dispute' ? 0 : 1,
            disputeRemark: this.disputeForm.disputeReason,
            orderDisputeFile: this.disputeForm.fileList.map(file => ({
              fileId: file.fileId,
              fileName: file.name,
              filePath: file.path,
              fileUrl: file.url,
              fileSize: file.size
            }))
          }
          
          // 根据角色调用不同的API
          const api = this.role === 'admin' ? adminApi : 
                     this.role === 'merchant' ? merchantApi : customerApi
          
          api.submitDispute(params)
            .then(res => {
              if (res) {
                this.$message.success('提交成功')
                this.$router.push(`/${this.role}/orders/dispute`)
              } else {
                this.$message.error('提交失败')
              }
            })
            .catch(error => {
              console.error('提交失败:', error)
              this.$message.error('提交失败: ' + (error.message || '未知错误'))
            })
            .finally(() => {
              this.loading = false
            })
        } else {
          this.$message.error('请正确填写表单')
          return false
        }
      })
    },
    // 取消
    cancel() {
      this.$router.push(`/${this.role}/orders/detail/${this.orderId}`)
    }
  }
}
</script>

<style scoped>
.dispute-submit-container {
  padding: 30px;
  background-color: #f5f7fa;
  min-height: 100vh;
}

.order-card {
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.page-header h2 {
  margin: 0;
  color: #303133;
  font-size: 24px;
}

.divider-title {
  font-size: 18px;
  font-weight: bold;
  color: #409EFF;
  position: relative;
  padding-left: 12px;
}

.divider-title::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  height: 18px;
  width: 4px;
  background-color: #409EFF;
  border-radius: 2px;
}

.file-list-container {
  margin-top: 20px;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
  border-radius: 4px;
  background-color: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
}

.file-list-title {
  margin: 0 0 20px 0;
  font-size: 16px;
  color: #303133;
  position: relative;
  padding-left: 12px;
  border-left: 3px solid #409EFF;
}

.no-file {
  padding: 40px 0;
}

.form-actions {
  margin-top: 30px;
  text-align: center;
}

.form-actions .el-button {
  padding: 12px 30px;
  font-size: 16px;
}

.dispute-form-card {
  background-color: #f9f9f9;
  margin-bottom: 20px;
  border: 1px solid #ebeef5;
}

.upload-demo {
  width: 100%;
}

.el-upload__text {
  color: #606266;
  font-size: 14px;
  text-align: center;
}

.el-upload__text em {
  color: #409EFF;
  font-style: normal;
}

.el-upload__tip {
  color: #909399;
  font-size: 12px;
  margin-top: 5px;
}

/* 确保所有textarea统一字体样式 */
::v-deep .el-textarea__inner {
  font-family: inherit !important;
  font-size: 14px !important;
  line-height: 1.5 !important;
  color: #606266 !important;
}
</style> 